import gql from 'graphql-tag';

export const readOwnerSettingsFrontend = gql`
  query ReadOwnerSettings {
    response: readOwnerSettings{
      daysBeforeReservationCanBeChanged
    }
  }
`;
